import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const organisationsDropdown = createAsyncThunk(
  'organistions/fetch_organisations',
  async (_, { rejectWithValue }) => {
    try {
      const response:any = await axios.get(
        'https://mastersappbe.kdcstaging.in/api/organization/',
        {
          headers: {
            Authorization: 'Token 0d8e5d9c3db24c76322edf22ca5d4f4f07931125'
          }
        }
      )
      return response.data?.results || [];
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong')
    }
  }
)
